import React, { ComponentType, useState } from 'react'
import uniqid from 'uniqid'
import classnames from 'classnames'
import { SustainableFitchSiteHeaderLinkProps } from '../..'
import { SubNavigationRelatedLinksProps } from '../../TopNavigation/SubNavigationRelatedLinks'

interface RenderLinkProps extends SustainableFitchSiteHeaderLinkProps {
  closeOverlayOnMenu?: () => void
}

export type SustainableFitchSiteHeaderMenuProps = {
  menus: SubNavigationRelatedLinksProps[]
  renderLink?: ComponentType<RenderLinkProps>
  closeOverlayOnMenu: () => void
}

const renderLinkDefault = ({
  className = '',
  label,
  slug,
  closeOverlayOnMenu = () => {}
}: RenderLinkProps) => (
  <a onClick={() => closeOverlayOnMenu()} className={className} href={slug}>
    {label}
  </a>
)

export const SustainableFitchSiteHeaderMenu = ({
  menus,
  closeOverlayOnMenu,
  renderLink: Link = renderLinkDefault
}: SustainableFitchSiteHeaderMenuProps) => {
  const [isActiveSubMenu, setActiveSubMenu] = useState('')
  const toggleSubMenu = (menu: string) => {
    setActiveSubMenu(menu === isActiveSubMenu ? '' : menu)
  }

  return (
    <>
      {menus.map(
        ({ label, relatedLinkHref, title, links = [] }, subNavigationIndex) => {
          const currentSubMenu = `${subNavigationIndex}-${label}`
          return (
            <React.Fragment key={uniqid()}>
              {links && links.length > 0 ? (
                <li
                  className={classnames({
                    'navigation__group-sub': true,
                    active: isActiveSubMenu === currentSubMenu
                  })}
                  onClick={() => toggleSubMenu(currentSubMenu)}
                  onKeyUp={() => toggleSubMenu(currentSubMenu)}
                  role="presentation"
                >
                  <span
                    className={classnames({
                      active: isActiveSubMenu === currentSubMenu
                    })}
                  >
                    {label}
                  </span>
                  <ul
                    className="menu menu-level--2"
                    style={{
                      display:
                        isActiveSubMenu === currentSubMenu ? 'block' : 'none'
                    }}
                  >
                    {links
                      .filter((link) => 'relatedLinkHref' in link)
                      .map((link) => (
                        <li
                          className="navigation__group-sub-sub"
                          key={uniqid()}
                        >
                          <Link
                            slug={link.relatedLinkHref}
                            label={link.label || ''}
                            closeOverlayOnMenu={closeOverlayOnMenu}
                          />
                        </li>
                      ))}
                  </ul>
                </li>
              ) : (
                <li className="navigation__group-sub">
                  <Link
                    closeOverlayOnMenu={closeOverlayOnMenu}
                    slug={relatedLinkHref}
                    label={label || title}
                  />
                </li>
              )}
            </React.Fragment>
          )
        }
      )}
    </>
  )
}
export default SustainableFitchSiteHeaderMenu
